import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PrinterOutlinedSvg from "@ant-design/icons-svg/es/asn/PrinterOutlined";
import AntdIcon from "../components/AntdIcon";
var PrinterOutlined = function PrinterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PrinterOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PrinterOutlined.displayName = 'PrinterOutlined';
}
export default /*#__PURE__*/React.forwardRef(PrinterOutlined);